import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSchool, FaLaptop, FaUsers, FaGraduationCap } from 'react-icons/fa';
import { UserContext } from '../UserContext';
import './PolymathKidSchool.css';
import Footer from '../Footer';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import schoolImage1 from '../../assets/school1.png';
import schoolImage2 from '../../assets/school2.png';
import physicalmode from '../../assets/physicalmode.png';
import onlinemode from '../../assets/onlinemode.png';
import { useNavigate } from 'react-router-dom';

const PolymathKidsSchools = () => {
  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: 'include',
      })
        .then((response) => {
          response.json().then((userInfo) => {
            setUserInfo(userInfo);
            if (userInfo?.usertype) {
              setUserRole(userInfo.usertype);
            }
          });
        })
        .catch((err) => console.log('Error in useEffect:', err));
    };
    fetchData();
  }, [isAdmin, isTeacher, isStudent, isGuest]);

  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    setUserRole('guest');
    navigate('/');
  };

  const username = userInfo?.username;
  const avatar = userInfo?.avatar;

  return (
    <>
      {/* Navbar */}
      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={avatar} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={avatar} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={avatar} onLogout={onLogout} />}
        </>
      )}

      {/* Section 1: Polymath-Kids @ Schools */}
      <section className="section1">
        <div className="section1-content">
          <h1>POLYMATH-KIDS </h1>
          <h1>  @ SCHOOLS</h1>
          <p>
            Polymath-Kids is the best platform for kids where they can learn 21st Century life skills in a structured and fun learning environment.
            Polymath-Kids directly collaborate with well reputed schools to provide valuable training for students. We provide the preeminent learning
            experience with SMART Training Portal that helps to boost the creativity, problem solving skills, ICT Literacy, mental calculation ability
            and overall cognitive skills in kids.
          </p>
          {/* moved below paragraph */}
          <div className="school-images">
            <img src={schoolImage1} alt="School 1" className="school-image school-image1" />
            <img src={schoolImage2} alt="School 2" className="school-image school-image2" />
          </div>
        </div>
      </section>

      {/* Section 2: Why 21st Century Life Skills Matter */}
      <section className="section2">
        <div className="section2-content">
          <h2>
            Why 21st Century Life <span className="highlight">Skills Matter</span>
          </h2>
          <p>
            We facilitate schools by offering two modes of teaching 21st Century Life Skills at schools:<br />
            <span className="bold">1. Physical Mode / Online Mode with school teachers</span><br />
            <span className="bold">2. Online Mode with Polymath-Kids instructors</span><br /><br />
            Polymath-Kids Programs can be introduced to students as part of their school curriculum or as an after-school activity. It can help students by improving their cognitive, leadership, social and people skills, concentration and memory power. The use of our program in schools can help by boosting confidence and problem solving ability. We offer two modes of classes for Schools.
          </p>
          <div className="image-container">
            <img src={physicalmode} alt="Physical Mode" className="mode-image physical-mode" />
            <img src={onlinemode} alt="Online Mode" className="mode-image online-mode" />
          </div>
          <div className="contact-button-container">
            <Link to="/contact_us">
              <button className="contact-info-button">Contact Us</button>
            </Link>
          </div>
        </div>
      </section>


      {/* Footer */}
      <Footer />
    </>
  );
};

export default PolymathKidsSchools;
